import React, { type HtmlHTMLAttributes, type ReactNode } from "react";

import classNames from "classnames";

import style from "./Stack.module.css";

export type StackProps = {
  children: ReactNode;
  className?: string;
  direction?: "row" | "column";
} & HtmlHTMLAttributes<HTMLDivElement>;

export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ children, className, direction: direction = "row", ...attrs }, ref) => {
    return (
      <div
        {...attrs}
        ref={ref}
        className={classNames(style.stack, direction === "column" && style.column, className)}
      >
        {children}
      </div>
    );
  }
);

Stack.displayName = "Stack";
